import VVideoUpload from './index.vue';

export default {
  install: (Vue) => Vue.component('VVideoUpload', VVideoUpload),
};
